import "./Mentorship.css";

// 1-on-1 online mentorship. Backed by real teaching experience:
// 500+ tutors trained, 250+ live sessions.
const topics = [
  "Python & Programming",
  "SQL & Databases",
  "Data Analytics (Power BI, dashboards)",
  "Data Science / ML intro",
  "Machine Learning",
  "Front-End Development",
];

const audience = [
  "Beginners & students",
  "Career switchers moving into data",
  "Working professionals upskilling",
];

const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Mentorship = () => {
  return (
    <div className="sec" id="mentorship">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> learn from me — 1:1 mentorship</div>

        <div className="mentor-grid">
          {/* left: pitch + credibility */}
          <div className="mentor-lead" data-aos="fade-up">
            <p className="mentor-tag">▸ live · online · one-on-one</p>
            <h3 className="mentor-h">Personal coaching in data &amp; development.</h3>
            <p className="mentor-desc">
              I've trained <b>500+ tutors</b> and delivered <b>250+ live sessions</b> across
              Python, ML, and web development. Now I offer focused <b>1:1 online classes</b> —
              paced to you, project-driven, and practical.
            </p>

            <div className="mentor-meta">
              <div className="mm-item">
                <span className="mm-num">500+</span>
                <span className="mm-label">learners trained</span>
              </div>
              <div className="mm-item">
                <span className="mm-num">250+</span>
                <span className="mm-label">live sessions</span>
              </div>
              <div className="mm-item">
                <span className="mm-num">5+ yrs</span>
                <span className="mm-label">teaching</span>
              </div>
            </div>

            <button className="mc-btn" onClick={scrollToContact}>▸ book an intro session</button>
            <p className="mentor-note">free intro chat · flexible scheduling · message me for details &amp; pricing</p>
          </div>

          {/* right: what + who */}
          <div className="mentor-side" data-aos="fade-up" data-aos-delay="100">
            <div className="mentor-block">
              <span className="mb-label">{"// topics"}</span>
              <ul className="mentor-list">
                {topics.map((t) => (<li key={t}>{t}</li>))}
              </ul>
            </div>
            <div className="mentor-block">
              <span className="mb-label">{"// who it's for"}</span>
              <ul className="mentor-list plain">
                {audience.map((a) => (<li key={a}>{a}</li>))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mentorship;